module.exports = __webpack_public_path__ + "img/goalpreview.2be1f5a2.png";